<template>
  <div class="about">
    <section class="page-header">
      <div class="container">
        <h1>关于我们</h1>
        <p>About us</p>
      </div>
    </section>

    <section class="company-intro">
      <div class="container">
        <div class="intro-content">
          <div class="intro-text">
            <h2>公司简介</h2>
            <p class="cn-text">广州沃仕顿机械设备有限公司，是一家集设计、生产和服务于一体的金属切削解决方案供应商。公司设立的工程中心，拥有特殊刀和专用工装夹具的设计能力，可以为客户提供金属切削整套工艺方案以及相关精密零部件，满足客户对各种特殊金属加工的需要。产品线涵盖：挤压丝锥、非标孔加工刀具、机夹非标刀具、各类夹头与非标量具、精密零部件和专用工装夹具、非标CNC设备、刀具再研磨服务等各项服务。我们会以专业的技术知识，承接客户专案工程，交钥匙工程。</p>
            <p class="en-text">Guangzhou VOSDOM Machinery Equipment Co.,Ltd. is a metal cutting solution provider integrating with design, production and service. The engineering center set up by the company has the design capability of special cutting tools and customized fixtures and provide complete process solutions of metal cutting and related precision parts to meet the needs of customer on special metal processing. The product line includes: thread taps, special hole machining tools，fixtures of special tools, various chucks and special gauges, precision parts and customized fixtures, special CNC equipment , tool re-grinding services . We promise to fulfill your projects perfectly with our technical knowledge.</p>
          </div>
        </div>
      </div>
    </section>

    <section class="mission-vision">
      <div class="container">
        <div class="mission-card">
          <h3>我们的使命</h3>
          <p>通过创新的技术和优质的产品，帮助客户提升生产效率，降低运营成本，实现可持续发展。</p>
        </div>
        <div class="vision-card">
          <h3>我们的愿景</h3>
          <p>成为行业内最受尊敬的机械设备供应商，推动中国制造业的智能化升级。</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'AboutPage'
}
</script>

<style scoped>
.about {
  margin-top: 80px;
}

.page-header {
  background: linear-gradient(to right,#0a338c,#0a338c);
  color: white;
  padding: 60px 0;
  text-align: center;
}

.page-header h1 {
  font-size: 2.5rem;
  margin-bottom: 15px;
}

.page-header p {
  font-size: 1.2rem;
  opacity: 0.9;
}

.company-intro {
  padding: 80px 0;
}

.intro-content {
  display: flex;
  gap: 40px;
  align-items: center;
}

.intro-text h2 {
  font-size: 2rem;
  margin-bottom: 20px;
  color: #333;
}

.cn-text {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #666;
  margin-bottom: 20px;
  text-align: justify;
}

.en-text {
  font-size: 1rem;
  line-height: 1.8;
  color: #999;
  margin-bottom: 20px;
  text-align: justify;
}

.mission-vision {
  padding: 60px 0;
  background-color: #f8f9fa;
}

.mission-vision .container {
  display: flex;
  gap: 30px;
}

.mission-card, .vision-card {
  flex: 1;
  background: white;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.mission-card h3, .vision-card h3 {
  font-size: 1.5rem;
  margin-bottom: 20px;
  color: #333;
}

.mission-card p, .vision-card p {
  font-size: 1.1rem;
  line-height: 1.6;
  color: #666;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

@media (max-width: 768px) {
  .about {
    margin-top: 140px;
  }
  
  .intro-content {
    flex-direction: column;
  }
  
  .mission-vision .container {
    flex-direction: column;
  }
  
  .page-header h1 {
    font-size: 2rem;
  }
  
  .page-header p {
    font-size: 1rem;
  }
  
  .company-intro {
    padding: 50px 0;
  }
  
  .team {
    padding: 50px 0;
  }
}
</style>